import Vue from 'vue';
import ProjektService from './projekt.service';
import * as _ from 'lodash';
import abstractStore from '../../store/abstractstore';

export const getDefaultSort = () => ({ currentSort: 'kunde.bezeichnung,bezeichnung', currentSortDir: 'asc' });

const getDefaultItem = () => ({
    bezeichnung: null,
    geloescht: false,
    kunde: null,
    id: null,
    soll: null,
    ist: null,
    farbe: '#175276',
    artikel: null,
    verrechenbar: false,
    overbookable: false,
    fixpreis: false,
});

const getDefaultSelectedKunde = () => ({});

const getDefaultState = () => ({
    item: getDefaultItem(),
    list: [],
    selectedKunde: getDefaultSelectedKunde(),
    currentPage: 0,
    totalPages: 1,
    selectedIncludeDeactivated: false,
    selectedPopulateIst: false,
    ...abstractStore.getAbstractValue(getDefaultSort().currentSort, getDefaultSort().currentSortDir),
});

const projekt = {
    namespaced: true,

    state: Object.assign({}, getDefaultState()),

    mutations: {
        update(state, data) {
            Vue.set(state, 'item', data);
        },
        updateList(state, data) {
            Vue.set(state, 'list', data);
        },
        updateCurrentPage(state, data) {
            Vue.set(state, 'currentPage', data);
        },
        updateTotalPages(state, data) {
            Vue.set(state, 'totalPages', data);
        },
        clear(state) {
            Vue.set(state, 'item', getDefaultState().item);
            Vue.set(state, 'list', getDefaultState().list);
        },
        selectedKunde(state, data) {
            Vue.set(state, 'selectedKunde', data);
        },
        selectedIncludeDeactivated(state, data) {
            Vue.set(state, 'selectedIncludeDeactivated', data);
        },
        selectedPopulateIst(state, data) {
            Vue.set(state, 'selectedPopulateIst', data);
        },
    },

    actions: {
        clear({ commit }) {
            commit('clear');
        },
        async create(context, client_data) {
            const { data } = await ProjektService.create(client_data);
            context.commit('update', data);
            return data;
        },
        async update(context, client_data) {
            const { data } = await ProjektService.update(client_data.id, client_data);
            context.commit('update', data);
            return data;
        },
        async get(context, id) {
            const { data } = await ProjektService.get(id);
            context.commit('update', data);
            return data;
        },
        async queryAll(context, params) {
            if ((params && params.params && params.params.init) === true && params.params.page === 0 && context.rootState.projekt.currentPage !== 0) {
                params.params.page = context.rootState.projekt.currentPage;
            }
            const { headers, data } = await ProjektService.queryAll(params);

            let currPage = params && params.params && params.params.page ? params.params.page : 0;
            context.commit('updateCurrentPage', currPage);

            let size = params && params.params && params.params.size ? params.params.size : 20;
            let totalCount = headers['x-total-count'];
            let totalPages = 1;

            if (_.toNumber(totalCount) > 0 && _.toNumber(size) > 0) {
                totalPages = _.toNumber(totalCount) / _.toNumber(size);
            }

            context.commit('updateTotalPages', _.ceil(totalPages));

            context.commit('updateList', data);
            return data;
        },
        async query(context, params) {
            if ((params && params.params && params.params.init) === true && params.params.page === 0 && context.rootState.projekt.currentPage !== 0) {
                params.params.page = context.rootState.projekt.currentPage;
            }
            const { headers, data } = await ProjektService.query(params);

            let currPage = params && params.params && params.params.page ? params.params.page : 0;
            context.commit('updateCurrentPage', currPage);

            let size = params && params.params && params.params.size ? params.params.size : 20;
            let totalCount = headers['x-total-count'];
            let totalPages = 1;

            if (_.toNumber(totalCount) > 0 && _.toNumber(size) > 0) {
                totalPages = _.toNumber(totalCount) / _.toNumber(size);
            }

            context.commit('updateTotalPages', _.ceil(totalPages));

            context.commit('updateList', data);
            return data;
        },
        async delete(context, slug) {
            await ProjektService.delete(slug);
        },
        async selectedKunde(context, kunde) {
            context.commit('selectedKunde', kunde);
        },
        selectedIncludeDeactivated(context, ugs) {
            context.commit('selectedIncludeDeactivated', ugs);
        },
        selectedPopulateIst(context, ugs) {
            context.commit('selectedPopulateIst', ugs);
        },
    },

    getters: {
        data(state) {
            return state.item;
        },
        list(state) {
            return state.list;
        },
        selectedKunde(state) {
            return state.selectedKunde;
        },
        selectedIncludeDeactivated(state) {
            return state.selectedIncludeDeactivated;
        },
        selectedPopulateIst(state) {
            return state.selectedPopulateIst;
        },
    },
};

export default _.merge(projekt, abstractStore.getDefaultStore());
